import { render, staticRenderFns } from "./BlockType4List.vue?vue&type=template&id=f55d9d4e&scoped=true"
import script from "./BlockType4List.vue?vue&type=script&lang=ts"
export * from "./BlockType4List.vue?vue&type=script&lang=ts"
import style0 from "./BlockType4List.vue?vue&type=style&index=0&id=f55d9d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55d9d4e",
  null
  
)

export default component.exports